import { motion,useReducedMotion } from 'framer-motion'
// import { ArrowRight, Paperclip } from 'lucide-react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
// import { Link } from 'react-router-dom'
import { Header } from '@/components/landing/Header'
import { MultiLanguageSupport } from '@/components/landing/MultiLanguageSupport'
import { FeaturesAlternatingAnimated } from '@/components/landing/FeaturesAlternatingAnimated'
import { HeroScene } from '@/components/landing/HeroScene'
import { LandingFooter } from '@/components/landing/LandingFooter'
import { Testimonials } from '@/components/landing/Testimonials'
import { Pricing } from '@/components/landing/Pricing'
import { Faq } from '@/components/landing/Faq'
import { ScrollToAnchor } from '@/components/ScrollToAnchor'
// import { Tabs,TabsList,TabsTrigger,TabsContent } from '@/components/ui/tabs'
import { PlatformIcon } from '@/components/brand-mentions/PlatformIcon'
import { toAbsoluteUrl } from '@/lib/seo'
import { MARKETING_ROUTES } from '@/lib/marketingRoutes'
import {
  BRAND_MENTION_PLATFORMS,
  PLATFORM_LABELS,
} from '@/types/brandMentions'
import './Landing.css'

function Reveal({ children,className='' }: { children: React.ReactNode; className?: string }) {
  const reduced=useReducedMotion()
  return <motion.div className={className} initial={reduced? false:{ opacity: 0,y: 32 }} whileInView={{ opacity: 1,y: 0 }}
    viewport={{ once: true,amount: 0.12 }}
    transition={{ duration: reduced? 0:0.7,ease: [0.22,1,0.36,1] }}>{children}</motion.div>
}

/*
function ProductFeatures({ fr }: { fr: boolean }) {
  const features=[
    { id: 'bugs',label: fr? 'Bugs':'Bug reports',title: fr? 'Le problème, avec son contexte.':'The problem. And the details behind it.',description: fr? 'Recevez les signalements depuis votre produit, avec captures d’écran et informations de navigation. Attribuez-les à votre équipe et suivez leur résolution.':'Capture reports inside your product, with screenshots and browser details attached. Assign them to your team and track each issue through to resolution.',image: '/images/bug_reports.jpg',alt: fr? 'Signalements de bugs dans Feedbask':'Bug reports and statuses in Feedbask' },
    { id: 'features',label: fr? 'Idées':'Feature requests',title: fr? 'Construisez ce qui compte pour eux.':'Build what your customers keep asking for.',description: fr? 'Rassemblez les idées et les votes pour comprendre les demandes récurrentes. Gardez vos décisions visibles avec une roadmap publique.':'Collect ideas and votes to understand which requests keep coming up. Share what’s planned, in progress, and shipped on your public roadmap.',image: '/images/interface/features.png',alt: fr? 'Demandes et votes dans Feedbask':'Customer feature requests and votes in Feedbask' },
    { id: 'surveys',label: fr? 'Enquêtes':'Surveys',title: fr? 'Posez la question au bon moment.':'Ask while the experience is still fresh.',description: fr? 'Recueillez les réponses NPS, CSAT et les retours directs dans votre produit. Comprenez le pourquoi derrière chaque note.':'Run NPS, CSAT, and feedback surveys inside your product. Understand the experience behind the score, while it’s still on your customer’s mind.',image: '/images/interface/Survey.png',alt: fr? 'Enquêtes clients dans Feedbask':'Customer survey responses in Feedbask' },
    { id: 'reviews',label: fr? 'Avis':'Reviews',title: fr? 'Faites entendre vos clients satisfaits.':'Let happy customers do the talking.',description: fr? 'Recueillez des avis depuis votre widget et retrouvez-les dans votre tableau de bord. Une façon simple de conserver les mots de vos clients.':'Collect customer reviews through your widget and manage them in your dashboard. Keep the words your customers use to describe your product.',image: '/images/interface/Reviews.png',alt: fr? 'Gestion des avis dans Feedbask':'Customer reviews in Feedbask' },
  ]
  const mobileExamples = [
    { name: 'Maya Chen', title: fr ? 'Le paiement bloque sur Safari' : 'Checkout fails on Safari', detail: fr ? 'Le bouton recouvre le prix sur mon iPhone.' : 'The button overlaps the price on my iPhone.', meta: 'Safari · iPhone · /checkout', status: fr ? 'En cours' : 'In progress' },
    { name: 'Tom Rivera', title: fr ? 'Un mode sombre pour le tableau de bord' : 'A dark mode for the dashboard', detail: fr ? 'Ce serait plus agréable pour travailler le soir.' : 'It would make working late a little easier on the eyes.', meta: fr ? '24 votes · Roadmap publique' : '24 votes · Public roadmap', status: fr ? 'Prévu' : 'Planned' },
    { name: 'Sarah Johnson', title: fr ? 'Comment s’est passée l’installation ?' : 'How was your first setup?', detail: fr ? 'Le widget prend vraiment deux minutes à installer.' : 'The widget really takes two minutes to install.', meta: 'CSAT · 5/5', status: fr ? 'Réponse reçue' : 'Response received' },
    { name: 'Emma Cole', title: fr ? 'Simple à intégrer. Simple à utiliser.' : 'Easy to install. Easy to use.', detail: fr ? 'Nous recevons enfin des retours là où nos clients travaillent.' : 'We finally hear from customers right where they work.', meta: fr ? 'Avis recueilli via le widget' : 'Collected through the widget', status: fr ? 'Nouvel avis' : 'New review' },
  ]
  return <section id="how-it-works" className="fb-section fb-container">
    <Reveal className="fb-section-heading">
      <p className="fb-eyebrow">{fr? 'Laissez la conversation commencer':'Let the conversation start'}</p>
      <h2>{fr? 'Un petit widget.':'One small widget.'}<br />
        <em>{fr? 'Beaucoup à apprendre.':'So much to learn.'}</em>
      </h2>
      <p>{fr? 'Plusieurs façons d’écouter. Un seul endroit à intégrer.':'Different ways to listen. One place to bring them together.'}</p>
    </Reveal>
    <Reveal>
      <Tabs defaultValue="bugs" className="fb-feature-tabs">
        <TabsList aria-label={fr? 'Fonctionnalités Feedbask':'Feedbask features'} className="fb-tabs-list">{features.map(feature => <TabsTrigger value={feature.id} key={feature.id}>{feature.label}</TabsTrigger>)}</TabsList>{features.map((feature, index) => <TabsContent key={feature.id} value={feature.id} className="fb-feature-panel">
          <div className="fb-feature-text">
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
            <Link to="/auth" className="fb-text-link">{fr? 'Essayer gratuitement':'Try it for free'} <ArrowRight size={16} />
            </Link>
          </div>
          <div className="fb-feature-mobile">
            <small>{fr ? 'Exemple de retour client' : 'Sample customer feedback'}</small>
            <div className="fb-mobile-feedback">
              <header><span>{mobileExamples[index].name}</span><span>{mobileExamples[index].status}</span></header>
              <h4>{mobileExamples[index].title}</h4>
              <p>{mobileExamples[index].detail}</p>
              {index === 0 && <span className="fb-mobile-attachment"><Paperclip size={14} /> screenshot.png</span>}
              <footer>{mobileExamples[index].meta}</footer>
            </div>
          </div>
          <div className="fb-feature-image">
            <img src={feature.image} alt={feature.alt} loading="lazy" />
          </div>
        </TabsContent>)}</Tabs>
    </Reveal>
  </section>
}
*/

export default function Landing() {
  const { i18n }=useTranslation()
  const fr=Boolean(i18n.language?.startsWith('fr'))
  const title=fr? 'Feedbask : le feedback client, tout simplement':'Feedbask: customer feedback, without the friction'
  const description=fr? 'Recueillez les bugs, idées et messages de vos clients. Répondez avec le contexte nécessaire et partagez vos avancées.':'Collect bug reports, feature requests, and customer messages. Respond with context, share your roadmap, and keep customers in the loop.'
  const home=fr? MARKETING_ROUTES.home.fr:MARKETING_ROUTES.home.en
  return <div className="fb-landing">
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={toAbsoluteUrl(home)} />
      <link rel="alternate" hrefLang="en" href={toAbsoluteUrl(MARKETING_ROUTES.home.en)} />
      <link rel="alternate" hrefLang="fr" href={toAbsoluteUrl(MARKETING_ROUTES.home.fr)} />
      <link rel="alternate" hrefLang="x-default" href={toAbsoluteUrl(MARKETING_ROUTES.home.en)} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={toAbsoluteUrl(home)} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
    <ScrollToAnchor />
    <a href="#main-content" className="fb-skip-link">{fr ? 'Aller au contenu' : 'Skip to content'}</a>
    <div className="fb-navigation">
      <Header />
    </div>
    <main id="main-content">
      <HeroScene fr={fr} />
      <div className="fb-trust fb-container">
        <p>{fr? 'Pour ceux qui construisent, et ceux qui les aident à avancer.':'For the people building products. And the people making them better.'}</p>
        <div>
          <span>{fr? 'Créateurs indépendants':'Independent makers'}</span>
          <span>{fr? 'Petites équipes':'Small teams'}</span>
          <span>{fr? 'Produits ambitieux':'Thoughtful products'}</span>
        </div>
      </div>
      <FeaturesAlternatingAnimated />
      {/* <ProductFeatures fr={fr} /> */}
      <Reveal><MultiLanguageSupport /></Reveal>
      <Testimonials />
      <section className="fb-section fb-container">
        <Reveal className="fb-section-heading">
          <h2>{fr? 'L’écoute ne s’arrête':'Keep listening.'}<br />
            <em>{fr? 'pas au widget.':'Keep moving.'}</em>
          </h2>
        </Reveal>
        <div className="fb-more-grid">{[
          { title: fr? 'Partagez la suite':'Share what’s next',text: fr? 'Une roadmap publique pour montrer les idées retenues et les nouveautés livrées.':'A public roadmap gives customers a window into what’s planned and what you’ve shipped.',tag: 'Roadmap' },
          { title: fr? 'Suivez les conversations':'Hear the wider conversation',text: fr? 'Suivez les mentions de votre marque au-delà de votre produit.':'Track brand mentions beyond your product and find the conversations worth joining.',tag: fr? 'Mentions de marque':'Brand mentions',platforms: true,plan: fr? 'Add-on +25 $/mois':'Add-on +$25/mo' },
          { title: fr? 'Travaillez ensemble':'Bring your team along',text: fr? 'Attribuez les demandes, partagez des notes et reliez vos outils avec les webhooks.':'Assign work, share internal notes, and connect your existing tools with webhooks.',tag: fr? 'Collaboration':'Teamwork' },
        ].map(item => <Reveal key={item.title} className="fb-neutral-card">
          <div className="fb-more-card-meta">
            <span className="fb-eyebrow">{item.tag}</span>
            {item.plan && <span className="fb-more-plan">{item.plan}</span>}
          </div>
          {item.platforms && (
            <div
              className="fb-more-platforms"
              aria-label={BRAND_MENTION_PLATFORMS.map((platform) => PLATFORM_LABELS[platform]).join(', ')}
            >
              {BRAND_MENTION_PLATFORMS.map((platform) => (
                <PlatformIcon
                  key={platform}
                  platform={platform}
                  className="h-5 w-5"
                  colored
                />
              ))}
            </div>
          )}
          <h3>{item.title}</h3>
          <p>{item.text}</p>
        </Reveal>)}</div>
      </section>
      <div className="fb-commerce fb-container">
        <Pricing />
        <Faq />
      </div>
    </main>
  <LandingFooter fr={fr} />
</div>
}
